export default "__VITE_ASSET__FfmeyyBe__"